import { baseUrl } from '@fs/zion-config'
import { useLocation } from '@fs/zion-router'
import { getFieldValue, getName, getGender } from './PersonUtil'
import { getFirstLetter } from './StringUtil'

const ANCESTRY_BASE_URL = 'https://www.ancestry.com/search'

export default () => {}

export function addUrlKeyValue(key, value) {
  if (value) {
    return `${key}=${encodeURIComponent(value)}`
  }
  return ''
}

export function addUrlQueryParams(url, params = {}) {
  if (!params || typeof params !== 'object') return url
  const [u, hash = ''] = url.split('#')
  const [base, q = ''] = u.split('?')
  const sp = new URLSearchParams(q)
  Object.entries(params)
    .filter(([, v]) => v != null && v !== '')
    .forEach(([k, v]) => {
      sp.set(k, v)
    })
  const qs = sp.toString()
  let result = base
  if (qs || hash) {
    const parts = [result]
    if (qs) {
      parts.push('?', qs)
    }
    if (hash) {
      parts.push('#', hash)
    }
    result = parts.join('')
  }
  return result
}

export function deleteLastPathElement(path) {
  if (path && path.indexOf('/') !== -1) {
    const array = path.split('/')
    array.pop()
    return array.join('/')
  }
  return path
}

export function useQueryParams() {
  const location = useLocation()
  return new URLSearchParams(location.search)
}

export function getBackendBaseUrl() {
  const path = '/service/dmc'
  const { REACT_APP_DMC_SERVER } = process.env
  if (REACT_APP_DMC_SERVER === 'localhost') {
    return 'http://localhost:8080'
  }
  return baseUrl + path
}

export function getFrontendBaseUrl(external) {
  let base = baseUrl
  if (external) {
    return base
  }
  if (window.location.hostname !== 'localhost') {
    base = `${base}/dmconsole`
  } else {
    base = window.location.origin
  }
  return base
}

export function createAncestryUrl(family, targetPerson) {
  const params = {}

  // Defaults to the principal so existing callers that only pass `family` are unaffected.
  const person = targetPerson || family.principal
  const isPrincipal = person?.personId === family.principal?.personId

  params.birthYear = getFieldValue(person?.birth?.value?.date).match(/\d{4}/)?.[0] || ''
  const birthPlace = getFieldValue(person?.birth?.value?.place)
  params.birth = `${params.birthYear}_${birthPlace}`

  const deathYear = getFieldValue(person?.death?.value?.date).match(/\d{4}/)?.[0] || ''
  const deathPlace = getFieldValue(person?.death?.value?.place)
  params.death = `${deathYear}_${deathPlace}`

  params.gender = getFirstLetter(getGender(person))
  params.name = getName(person, '_').name || ''

  // The family object only carries the principal's parents/spouse, so relative
  // context is only meaningful when searching for the principal.
  if (isPrincipal) {
    let father = family.parents1[0]
    let mother = family.parents2[0]
    if (father === 'FEMALE') {
      // we assume that first parent is father and second is mother, but if the first parent is female, then we switch them. This takes into account the possibility that gender could be UNKNOWN. in that case we assign parent1 as father
      const temp = father
      father = mother
      mother = temp
    }

    params.father = getName(father, '_').name || ''
    params.mother = getName(mother, '_').name || ''
    params.spouse = getName(family.spouses[0], '_').name || ''
  }
  params.searchMode = 'advanced'

  const url = addUrlQueryParams(ANCESTRY_BASE_URL, params)
  return url
}
